import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import List from '../../../../../../../components/common/List';
import commify from '../../../../../../../modules/ajio-util/commify.js';
import FacetCheckboxModalContent from './FacetCheckboxModalContent';
import FacetL1CategoryList from './FacetL1CategoryList';
import FacetCheckboxModalContentL3Category from './FacetCheckboxModalContentL3Category';
import { getLuxeFlags } from '../../../../../../../Flags/selectors';
import { FLEEK_STORE } from '../../../../../../../constants/constant';

class FacetFilterModalRightPane extends React.Component {
  constructor(props) {
    super(props);
    const { luxe } = props;
    this.state = {
      config: {
        brand: {
          showSearch: true,
          showPopular: true,
          searchInputPlaceHolder: luxe ? 'Search by brand name' : 'Search for brands',
          groupByAlphabets: true,
          showSelectedTopValues: false
        }
      }
    };
  }

  /**
   * entityId -> is the selectedFilter on left panel
   * Match the entityId with entities to find the vlaues to be displayed on right panel
   * acc will have the results (Right pane values)
   * acc = { results: [], entities: {} }
   * acc = { entities:boys:{count: 7}, results:Array(1) }
   */
  getL1Categories(entityId) {
    const { entities = {} } = this.props;
    const parentEntity = entities[entityId] || {};
    let { name = '', childrens = [], code } = parentEntity;

    return childrens.reduce(
      (acc, entityId) => {
        const entity = entities[`${entityId}`] || {};
        const { name = '', count } = entity;
        const nameSplits = name.split('-');
        let l1Category;
        if (nameSplits[0]) {
          l1Category = nameSplits[0].trim().toLowerCase();
        }
        if (l1Category && !acc.entities[l1Category]) {
          acc.results.push(l1Category);
          acc.entities[l1Category] = { count };
        } else if (l1Category && acc.entities[l1Category]) {
          acc.entities[l1Category].count = acc.entities[l1Category].count + count;
        }
        return acc;
      },
      { results: [], entities: {} }
    );
  }

  handleClick = id => {
    this.props.selectFilter(id);
    this.props.setSeletedL1Category();
  };

  checkCategory = (entities, query) => {
    const {
      genderfilter: genderfilterVal = {},
      l1l3nestedcategory: l1l3nestedcategoryVal = {}
    } = entities;
    const { childrens: genderfilterChild = [] } = genderfilterVal;
    const { childrens: categoryChild = [] } = l1l3nestedcategoryVal;
    const { genderfilter = [], l1l3nestedcategory = [] } = query;
    const { isFilterImprovementEnabled = false, plpGender = '' } = this.props;
    let textValue = '';
    if (
      genderfilterChild.length > 1 &&
      categoryChild.length > 1 &&
      genderfilter.length === 0 &&
      l1l3nestedcategory.length === 0 &&
      !(isFilterImprovementEnabled && plpGender && plpGender?.toLowerCase !== 'general')
    ) {
      textValue = 'select gender and category';
    } else if (categoryChild.length > 1 && l1l3nestedcategory.length === 0) {
      textValue = 'select a category';
    }
    return textValue;
  };

  render() {
    let {
      entities,
      selectedFilter,
      setRightPaneFormValues,
      rightPaneFormValues,
      seletedL1Category,
      setSeletedL1Category,
      selectedFacets,
      query,
      luxe,
      showSearchBar,
      clearFilters,
      clearFilterState,
      applyFilters,
      oldFlow,
      isFleek,
      isFromFilter = false,
      popupFilterFromBottom = false,
      addressBook = {},
      facets = {},
      isLimitedScrollLandingPage = false,
      isFromPopup = false
    } = this.props;
    const {
      isFilterImprovementEnabled = false,
      isFilterImprovementPhase2Enabled = false,
      plpGender = '',
      filterImprovementConfig = {}
    } = this.props;
    const { config = {} } = this.state;
    const entity = entities[selectedFilter] || {};
    const { childrens = [], code } = entity;
    const checkCategorySelected = this.checkCategory(entities, query);
    const l1Categories = this.getL1Categories(selectedFilter);
    if (
      !seletedL1Category &&
      l1Categories &&
      l1Categories.results &&
      l1Categories.results.length === 1
    ) {
      seletedL1Category = l1Categories.results[0];
      l3CategoryDisableBackButton = true;
    }

    // NOTE: FOR FILTER IMPROVEMENT
    const shouldSkipL1Category =
      isFilterImprovementEnabled &&
      ((plpGender && plpGender.toLowerCase() !== 'general') || query?.genderfilter?.length === 1);

    let l3CategoryDisableBackButton =
      shouldSkipL1Category ||
      (isFilterImprovementEnabled && l1Categories?.results?.length === 1) ||
      false;
    let paneNode = null;
    if (selectedFilter === 'advancedFilter') {
      paneNode = (
        <div className="facet-advanced-category-selection">
          <div
            className="facet-advanced-filter-description"
            style={isFleek ? { color: '#FFF' } : {}}
          >
            Please select upto 3 categories to view more filters
          </div>
          <div
            className="rilrtl-button rilrtl-button--select-category"
            onClick={() => this.handleClick('l1l3nestedcategory')}
            style={isFleek ? { background: '#1B1F23' } : {}}
            role="button"
            tabIndex={0}
          >
            <strong>Select Category</strong>
          </div>
        </div>
      );
    } else if (code !== 'l1l3nestedcategory' && code !== 'verticalsizegroupformat') {
      paneNode = (
        <FacetCheckboxModalContent
          popupFilterFromBottom={popupFilterFromBottom}
          addressBook={addressBook}
          showHidePriceRangeModal={this.props.showHidePriceRangeModal}
          parentEntityId={selectedFilter}
          setRightPaneFormValues={setRightPaneFormValues}
          rightPaneFormValues={rightPaneFormValues}
          config={config[code]}
          fetchFacets={this.props.fetchFacets}
          fetchNextFacets={this.props.fetchNextFacets}
          selectedFacets={selectedFacets}
          pushToHistory={this.props.pushToHistory}
          clickedFilterTabCode={this.props.clickedFilterTabCode}
          renderPriceRangeForm={this.props.renderPriceRangeForm}
          isFloatOrFocusChanged={this.props.isFloatOrFocusChanged}
          includeUnratedProducts={this.props.includeUnratedProducts}
          updateIncludeUnrated={this.props.updateIncludeUnrated}
          oldFlow={oldFlow}
          isFilterImprovementEnabled={isFilterImprovementEnabled}
          isFilterImprovementPhase2Enabled={isFilterImprovementPhase2Enabled}
          filterImprovementConfig={filterImprovementConfig}
          facets={facets}
          isLimitedScrollLandingPage={isLimitedScrollLandingPage}
          isFromPopup={isFromPopup}
          resetFilterTabsSelectedFacets={this.props.resetFilterTabsSelectedFacets}
        />
      );
      // } else if (code === 'l1l3nestedcategory' && !seletedL1Category) {
    } else if (code === 'l1l3nestedcategory' && !seletedL1Category && !shouldSkipL1Category) {
      const selectedGenders = query?.genderfilter && !!query?.genderfilter?.length;
      const genderFilters = (query?.genderfilter || [])?.map(el => el.toLowerCase());
      const filteredL1Categories =
        isFilterImprovementEnabled && selectedGenders
          ? {
              ...l1Categories,
              results: l1Categories.results.filter(el => genderFilters.includes(el))
            }
          : l1Categories;

      paneNode = (
        <FacetL1CategoryList
          parentEntityId={selectedFilter}
          setRightPaneFormValues={setRightPaneFormValues}
          rightPaneFormValues={rightPaneFormValues}
          seletedL1Category={seletedL1Category}
          setSeletedL1Category={setSeletedL1Category}
          selectedFacets={selectedFacets}
          l1Categories={filteredL1Categories}
          luxe={luxe}
          isFleek={isFleek}
          isFromFilter={isFromFilter}
          facets={facets}
        />
      );
    } else if (code === 'l1l3nestedcategory' && (seletedL1Category || shouldSkipL1Category)) {
      paneNode = (
        <FacetCheckboxModalContentL3Category
          parentEntityId={selectedFilter}
          setRightPaneFormValues={setRightPaneFormValues}
          rightPaneFormValues={rightPaneFormValues}
          seletedL1Category={
            seletedL1Category ||
            (query?.genderfilter?.length > 0 && query?.genderfilter?.[0]?.toLowerCase()) ||
            plpGender.toLowerCase() ||
            ''
          }
          setSeletedL1Category={setSeletedL1Category}
          disableBackButton={l3CategoryDisableBackButton}
          showSearchBar={showSearchBar}
          clearFilters={clearFilters}
          clearFilterState={clearFilterState}
          applyFilters={applyFilters}
          oldFlow={oldFlow}
          isFilterImprovementEnabled={isFilterImprovementEnabled}
          shouldHideCategoryTitle={isFilterImprovementEnabled && l3CategoryDisableBackButton}
          filterImprovementConfig={filterImprovementConfig}
          popupFilterFromBottom={popupFilterFromBottom}
          facets={facets}
        />
      );
    } else if (code === 'verticalsizegroupformat') {
      paneNode = (
        <div>
          {checkCategorySelected && !luxe && (
            <div
              className="facet-size-fit-category-description"
              aria-label={`For better results, ${checkCategorySelected}`}
              style={isFleek ? { color: '#FFF', paddingTop: '20px' } : {}}
            >
              For better results,
              <span
                className="select-category-text"
                onClick={() => this.handleClick('l1l3nestedcategory')}
                style={isFleek ? { color: '#EBFF00' } : {}}
              >
                {' '}
                {checkCategorySelected}
              </span>
            </div>
          )}
          <FacetCheckboxModalContent
            showHidePriceRangeModal={this.props.showHidePriceRangeModal}
            parentEntityId={selectedFilter}
            setRightPaneFormValues={setRightPaneFormValues}
            rightPaneFormValues={rightPaneFormValues}
            config={config[code]}
            fetchFacets={this.props.fetchFacets}
            fetchNextFacets={this.props.fetchNextFacets}
            selectedFacets={selectedFacets}
            clickedFilterTabCode={this.props.clickedFilterTabCode}
            renderPriceRangeForm={this.props.renderPriceRangeForm}
            isFloatOrFocusChanged={this.props.isFloatOrFocusChanged}
            includeUnratedProducts={this.props.includeUnratedProducts}
            updateIncludeUnrated={this.props.updateIncludeUnrated}
            oldFlow={oldFlow}
            isFilterImprovementPhase2Enabled={isFilterImprovementPhase2Enabled}
            facets={facets}
          />
        </div>
      );
    }
    return (
      <div
        className={`${luxe ? 'facet-filter-luxe-right-pane' : 'facet-filter-right-pane'} ${
          luxe && isFilterImprovementPhase2Enabled && code === 'verticalsizegroupformat'
            ? 'luxe-filter_improvement__size'
            : ''
        } facet-auto-scroll`}
        style={isFleek ? { background: oldFlow !== undefined ? '#060C10' : '#2E343A' } : {}}
      >
        {paneNode}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { flags, metaData, facets = {} } = state;
  const { name } = metaData;
  const { nextFacets = {}, plpGender = '' } = facets || {};
  const { groupResults = [], groupEntities = {}, entities = {}, query = {} } = nextFacets;
  let items = [];
  const luxeFlags = getLuxeFlags(flags);
  const { isThemeEnable } = luxeFlags;
  const luxe = isThemeEnable === 'ON' && name === 'luxe';
  const isFleek = name === FLEEK_STORE;
  const finalPlpGender = plpGender;

  if (groupEntities.All && groupEntities.All.items) {
    items = groupEntities.All.items;
  }
  return {
    groupResults,
    groupEntities,
    items,
    entities,
    query,
    luxe,
    isFleek,
    plpGender: finalPlpGender
  };
}

export default withRouter(connect(mapStateToProps)(FacetFilterModalRightPane));
